if (!customElements.get('product-media-slider')) {
  class ProductMediaSlider extends HTMLElement {
    constructor() {
      super();
      this.handlePrevClick = this.handlePrevClick.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);
      this.handleDotClick = this.handleDotClick.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.handleMouseDown = this.handleMouseDown.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleMouseUp = this.handleMouseUp.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.slides = this.querySelectorAll('.product-item__slide');
      this.dots = this.querySelectorAll('.product-item__dot');
      this.dotsContainer = this.querySelector('.product-item__dots');
      this.prevButton = this.querySelector('.product-item__arrow--prev');
      this.nextButton = this.querySelector('.product-item__arrow--next');

      if (this.slides.length < 2) return;

      this.currentIndex = 0;
      this.dragStartX = 0;
      this.isDragging = false;

      this.slides[0]?.classList.add('is-active');

      this.prevButton?.addEventListener('click', this.handlePrevClick);
      this.nextButton?.addEventListener('click', this.handleNextClick);
      this.dotsContainer?.addEventListener('click', this.handleDotClick);

      this.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd, { passive: true });
      this.addEventListener('mousedown', this.handleMouseDown);
      this.addEventListener('click', this.handleClick, true);
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.handlePrevClick);
      this.nextButton?.removeEventListener('click', this.handleNextClick);
      this.dotsContainer?.removeEventListener('click', this.handleDotClick);
      this.removeEventListener('touchstart', this.handleTouchStart);
      this.removeEventListener('touchend', this.handleTouchEnd);
      this.removeEventListener('mousedown', this.handleMouseDown);
      this.removeEventListener('click', this.handleClick, true);
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }

    goToSlide(index) {
      const totalSlides = this.slides.length;
      const nextIndex = ((index % totalSlides) + totalSlides) % totalSlides;

      if (nextIndex === this.currentIndex) return;

      const prevDot = this.dots[this.currentIndex];
      const prevSlide = this.slides[this.currentIndex];

      prevSlide?.classList.remove('is-active');
      if (prevDot) {
        prevDot.classList.remove('is-active');
        prevDot.setAttribute('aria-selected', 'false');
        prevDot.setAttribute('tabindex', '-1');
      }

      this.currentIndex = nextIndex;

      const nextDot = this.dots[this.currentIndex];
      const nextSlide = this.slides[this.currentIndex];

      nextSlide?.classList.add('is-active');
      if (nextDot) {
        nextDot.classList.add('is-active');
        nextDot.setAttribute('aria-selected', 'true');
        nextDot.removeAttribute('tabindex');
      }
    }

    handlePrevClick(event) {
      event.preventDefault();
      this.goToSlide(this.currentIndex - 1);
    }

    handleNextClick(event) {
      event.preventDefault();
      this.goToSlide(this.currentIndex + 1);
    }

    handleDotClick(event) {
      const dot = event.target.closest('.product-item__dot');
      if (!dot) return;
      event.preventDefault();
      this.goToSlide([...this.dots].indexOf(dot));
    }

    handleTouchStart(event) {
      if (event.touches.length === 1) {
        this.dragStartX = event.touches[0].clientX;
      }
    }

    handleTouchEnd(event) {
      if (event.changedTouches.length !== 1) return;

      const dragEndX = event.changedTouches[0].clientX;
      const dragDistance = this.dragStartX - dragEndX;
      const swipeThreshold = 50;

      if (Math.abs(dragDistance) > swipeThreshold) {
        this.goToSlide(this.currentIndex + (dragDistance > 0 ? 1 : -1));
      }
    }

    handleMouseDown(event) {
      this.dragStartX = event.clientX;
      this.isDragging = false;
      event.preventDefault();
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    }

    handleMouseMove(event) {
      if (Math.abs(event.clientX - this.dragStartX) > 5) {
        this.isDragging = true;
      }
    }

    handleMouseUp(event) {
      const dragDistance = this.dragStartX - event.clientX;

      if (Math.abs(dragDistance) > 50) {
        this.goToSlide(this.currentIndex + (dragDistance > 0 ? 1 : -1));
      }

      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }

    handleClick(event) {
      if (this.isDragging) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
      }
    }
  }

  customElements.define('product-media-slider', ProductMediaSlider);
}
